import React from 'react'
import 'react-sweet-progress/lib/style.css'
import ProgressBar from '../../Shared/ProgressBar'
import './myskill.css'

const MySkill = () => {
    return (
        <div id="skill" className="max-w-7xl mx-auto px-10 my-20">
            <h2 class="text-4xl text-center text-warning font-bold">I'm Expert On</h2>
            <div className="grid lg:grid-cols-2 gap-10 mt-10">
                <div data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1000" className="lg:px-10">
                    <ProgressBar title="HTML" clr="#fbc630" percentage={90} />
                    <ProgressBar title="Tailwind" clr="green" percentage={80} />
                    <ProgressBar title="JavaScript" clr="#fbc630" percentage={75} />
                    <ProgressBar title="TypeScript" clr="#6A67CE" percentage={50} />
                    <ProgressBar title="MongoDB" clr="#8D8DAA" percentage={60} />
                    <ProgressBar title="PHP" clr="#E1701A" percentage={40} />
                </div>
                <div data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1000" className="lg:px-10">
                    <ProgressBar title="CSS" clr="red" percentage={75} />
                    <ProgressBar title="Bootstrap" clr="#205375" percentage={80} />
                    <ProgressBar title="React" clr="goldenrod" percentage={70} />
                    <ProgressBar title="Node.Js" clr="orange" percentage={55} />
                    <ProgressBar title="Express.Js" clr="#1A132F" percentage={50} />
                    <ProgressBar title="MySql" clr="#A35709" percentage={40} />
                </div>
            </div>
        </div>
    )
}

export default MySkill
